import React from 'react'
import PropTypes from 'prop-types'
import { Table, Label, Loader, Icon } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { CRUDIndex } from '../CRUD'
import { EditDeleteButtonContainer } from '../../containers'
import { maskCurrency } from '../../utils/masks'

const FonteEnergia = (props) => (
  <CRUDIndex
    title='Fontes de Energia'
    icon='lightning'
    onRedirectToNew={props.onRedirectToNew}
    onExportToCSV={props.onExportToCSV}
    filterText={props.filterText}
    handleFilter={props.handleFilter}
  >
    <Table sortable celled striped selectable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={1} textAlign='center'
            onClick={props.handleSort('id')}
            sorted={props.handleSorted('id')}>#</Table.HeaderCell>
          <Table.HeaderCell width={3}
            onClick={props.handleSort('nome')}
            sorted={props.handleSorted('nome')}>Nome</Table.HeaderCell>
          <Table.HeaderCell
            onClick={props.handleSort('descricao')}
            sorted={props.handleSorted('descricao')}>Descrição</Table.HeaderCell>
          <Table.HeaderCell width={2} textAlign='center'
            onClick={props.handleSort('incentivada')}
            sorted={props.handleSorted('incentivada')}>Incentivada?</Table.HeaderCell>
          <Table.HeaderCell width={2} textAlign='center'
            onClick={props.handleSort('incentivo')}
            sorted={props.handleSorted('incentivo')}>Incentivo (%)</Table.HeaderCell>
          <Table.HeaderCell width={1}></Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {props.isLoading && (
          <Table.Row>
            <Table.Cell colSpan='6'>
              <Loader active={props.isLoading} inline='centered' />
            </Table.Cell>
          </Table.Row>
        )}
        {props.multipleFonteEnergia.valueSeq().map((fonteEnergia, index) => (
          <Table.Row key={index}>
            <Table.Cell textAlign='center'>
              <Label as={Link} to={`/fontes_energia/${fonteEnergia.get('id')}`}>
                {fonteEnergia.get('id')}
              </Label>
            </Table.Cell>
            <Table.Cell>{fonteEnergia.get('nome')}</Table.Cell>
            <Table.Cell>{fonteEnergia.get('descricao')}</Table.Cell>
            <Table.Cell textAlign='center'>{fonteEnergia.get('incentivada') ? <Icon name='thumbs up' color='green' size='big' /> : ''}</Table.Cell>
            <Table.Cell textAlign='center'>{maskCurrency.parse(fonteEnergia.get('incentivo') * 100)}</Table.Cell>
            <Table.Cell textAlign='right'>
              <EditDeleteButtonContainer
                onEditResource={() => props.onEditResource(fonteEnergia.get('id'))}
                onDeleteResource={() => props.onDeleteResource(fonteEnergia.get('id'))} />
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  </CRUDIndex>
)

FonteEnergia.propTypes = {
  onRedirectToNew: PropTypes.func,
  multipleFonteEnergia: PropTypes.object,
  onEditResource: PropTypes.func,
  onDeleteResource: PropTypes.func,
  handleSort: PropTypes.func,
  handleSorted: PropTypes.func,
  filterText: PropTypes.string,
  handleFilter: PropTypes.func,
  onExportToCSV: PropTypes.func,
  isLoading: PropTypes.bool,
}

export default FonteEnergia
